import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.element.content)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: _normalizeClass(_ctx.cssClasses),
                style: { "white-space": "pre-line" }
            }, _toDisplayString(_ctx.element.content), 3)
        ]))
        : _createCommentVNode("", true);
}
